const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 5 13)",
  stroke: "#0081CC"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 5 29)",
  stroke: "#0081CC"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 7,
  height: 9,
  transform: "matrix(1 0 0 -1 21 13)",
  stroke: "#0081CC"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.7344 27.4921C19.7344 27.2937 19.7952 27.1209 19.9168 26.9737C20.0448 26.8265 20.2048 26.7273 20.3968 26.6761C20.4224 26.6697 20.464 26.6665 20.5216 26.6665C20.8544 26.6665 21.0976 26.7977 21.2512 27.0601C21.3344 27.1881 21.376 27.3321 21.376 27.4921C21.376 27.6713 21.3216 27.8345 21.2128 27.9817C21.1104 28.1225 20.9696 28.2217 20.7904 28.2793C20.7328 28.2921 20.656 28.2985 20.56 28.2985C20.3552 28.2985 20.1792 28.2377 20.032 28.1161C19.8336 27.9625 19.7344 27.7545 19.7344 27.4921Z",
  fill: "#1E3F6B"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M22.8 27.4921C22.8 27.2937 22.8608 27.1209 22.9824 26.9737C23.1104 26.8265 23.2704 26.7273 23.4624 26.6761C23.488 26.6697 23.5296 26.6665 23.5872 26.6665C23.92 26.6665 24.1632 26.7977 24.3168 27.0601C24.4 27.1881 24.4416 27.3321 24.4416 27.4921C24.4416 27.6713 24.3872 27.8345 24.2784 27.9817C24.176 28.1225 24.0352 28.2217 23.856 28.2793C23.7984 28.2921 23.7216 28.2985 23.6256 28.2985C23.4208 28.2985 23.2448 28.2377 23.0976 28.1161C22.8992 27.9625 22.8 27.7545 22.8 27.4921Z",
  fill: "#1E3F6B"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M25.8656 27.4921C25.8656 27.2937 25.9264 27.1209 26.048 26.9737C26.176 26.8265 26.336 26.7273 26.528 26.6761C26.5536 26.6697 26.5952 26.6665 26.6528 26.6665C26.9856 26.6665 27.2288 26.7977 27.3824 27.0601C27.4656 27.1881 27.5072 27.3321 27.5072 27.4921C27.5072 27.6713 27.4528 27.8345 27.344 27.9817C27.2416 28.1225 27.1008 28.2217 26.9216 28.2793C26.864 28.2921 26.7872 28.2985 26.6912 28.2985C26.4864 28.2985 26.3104 28.2377 26.1632 28.1161C25.9648 27.9625 25.8656 27.7545 25.8656 27.4921Z",
  fill: "#1E3F6B"
});

const SvgEquationMatrix1 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationMatrix1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-matrix-1.925c91fc.svg";
export { ForwardRef as ReactComponent };